// Norwegian translations
export const no: Record<string, string> = {
  'menu.dashboard': 'Dashbord',
  'menu.orderNew': 'Produktregistrering',
  'menu.deliveryList': 'Leveringsliste',
  'menu.delivery': 'Levering',
  'menu.receipt': 'Skriv ut kvittering/etikett',
  'menu.definitions': 'Definisjoner',
  'menu.customers': 'Kunder',
  'menu.products': 'Produktdefinisjoner',
  'menu.pricing': 'Prisdefinisjoner',
  'menu.tailoring': 'Skredderioperasjoner',
  'menu.attributes': 'Produktattributter',
  'menu.users': 'Brukere',
  'menu.productOrdering': 'Produktrekkefølge',
  'menu.discounts': 'Rabattdefinisjoner',
  'menu.settings': 'Innstillinger',
  'menu.generalSettings': 'Generelle innstillinger',
  'menu.permissions': 'Tillatelsesstyring',
  'menu.subscription': 'Abonnement',
  'menu.invoices': 'Fakturastyring',
  'menu.expenses': 'Utgiftsregistrering',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Rapporter og regnskap',
  'menu.systemAndCommunication': 'System og kommunikasjon',
  'menu.reportsList': 'Kvitteringsliste',
  'menu.accountStatement': 'Kontoutskrift',
  'menu.tickets': 'Støtteforespørsler',
  'menu.support': 'Støtte',
  'menu.profile': 'Profil',
  'menu.logout': 'Logg ut',
  'menu.notifications': 'SMS/WhatsApp-varsler',
  'menu.whatsappConnection': 'WhatsApp-tilkobling',
  'menu.smsConnection': 'SMS-tilkobling',
  'dashboard.title': 'Dashbord',
  'dashboard.todaySales': 'Dagens salg',
  'dashboard.totalOrders': 'Totale bestillinger',
  'dashboard.pendingDeliveries': 'Ventende leveringer',
  'dashboard.activeCustomers': 'Aktive kunder',
  'dashboard.recentOrders': 'Nylige bestillinger',
  'dashboard.viewAll': 'Vis alle',
  'dashboard.quickActions': 'Hurtighandlinger',
  'dashboard.newOrder': 'Ny bestilling',
  'dashboard.newCustomer': 'Ny kunde',
  'dashboard.deliveries': 'Leveringer',
  'dashboard.reports': 'Rapporter',
  'dashboard.today': 'I dag',
  'dashboard.yesterday': 'I går',
  'dashboard.week': 'Uke',
  'dashboard.month': 'Måned',
  'dashboard.quarter': 'Kvartal',
  'dashboard.year': 'År',
  'dashboard.totalRevenue': 'Total inntekt',
  'dashboard.totalOrdersCard': 'Totale bestillinger',
  'dashboard.totalPieces': 'Totale varer',
  'dashboard.cancelled': 'Kansellert',
  'dashboard.inProcess': 'Under behandling',
  'dashboard.inProcessDesc': 'Bestillinger under behandling',
  'dashboard.ready': 'Klar',
  'dashboard.readyDesc': 'Bestillinger klare for levering',
  'dashboard.delivered': 'Levert',
  'dashboard.deliveredDesc': 'Fullførte bestillinger',
  'dashboard.announcements': 'Kunngjøringer',
  'dashboard.announcementAll': 'Generelt',
  'dashboard.announcementPrivate': 'Privat',
  'order.title': 'Ny bestilling',
  'order.customer': 'Kunde',
  'order.selectCustomer': 'Velg kunde',
  'order.newCustomer': 'Ny kunde',
  'order.products': 'Produkter',
  'order.addProduct': 'Legg til produkt',
  'order.selectProduct': 'Velg produkt',
  'order.quantity': 'Antall',
  'order.price': 'Pris',
  'order.total': 'Totalt',
  'order.discount': 'Rabatt',
  'order.subtotal': 'Delsum',
  'order.tax': 'MVA',
  'order.grandTotal': 'Totalsum',
  'order.payment': 'Betaling',
  'order.paymentMethod': 'Betalingsmetode',
  'order.cash': 'Kontanter',
  'order.card': 'Kredittkort',
  'order.credit': 'Kreditt',
  'order.amountPaid': 'Betalt beløp',
  'order.remainingBalance': 'Gjenværende saldo',
  'order.deliveryDate': 'Leveringsdato',
  'order.notes': 'Notater',
  'order.createOrder': 'Opprett bestilling',
  'order.cancel': 'Avbryt',
  'users.title': 'Brukere',
  'users.addNew': 'Ny bruker',
  'users.name': 'Navn',
  'users.email': 'E-post',
  'users.role': 'Rolle',
  'users.pin': 'PIN',
  'users.permissions': 'Tillatelser',
  'users.allPermissions': 'Alle tillatelser',
  'users.permissionCount': '{count} tillatelser',
  'users.changePin': 'Endre PIN',
  'users.edit': 'Rediger',
  'users.delete': 'Slett',
  'users.newUser': 'Ny bruker',
  'users.editUser': 'Rediger bruker',
  'users.editingUser': 'Redigerer {name}',
  'users.deleteUserTitle': 'Slett bruker',
  'users.deletingUser': 'Er du sikker på at du vil slette {name}?',
  'users.pinCode': 'PIN-kode (4-6 sifre)',
  'users.selectRole': 'Velg rolle',
  'users.patron': 'Eier',
  'users.kasiyer': 'Kasserer',
  'users.sofor': 'Sjåfør',
  'users.changePinTitle': 'Endre PIN-kode',
  'users.newPin': 'Ny PIN-kode',
  'users.confirmPin': 'Bekreft PIN-kode',
  'users.pinMismatch': 'PIN-kodene stemmer ikke',
  'users.pinRequired': 'PIN-kode kreves',
  'users.pinLength': 'PIN-koden må være 4-6 sifre',
  'users.changingPinFor': 'Endrer PIN for {name}',
  'products.title': 'Produktdefinisjoner',
  'products.addNew': 'Nytt produkt',
  'products.category': 'Kategori',
  'products.name': 'Produktnavn',
  'products.price': 'Pris',
  'products.color': 'Farge',
  'products.active': 'Aktiv',
  'products.actions': 'Handlinger',
  'products.search': 'Søk produkt...',
  'products.noProducts': 'Ingen produkter funnet',
  'products.noCategoryProducts': 'Ingen produkter i denne kategorien',
  'products.emptyCart': 'Handlekurven er tom',
  'service.tailor': 'Skredder',
  'service.dryCleaning': 'Renseri',
  'service.washing': 'Vask',
  'service.ironing': 'Stryking',
  'service.shoeShine': 'Skopuss',
  'service.carpet': 'Teppe',
  'service.tailoring': 'Skredderi endringer',
  'service.carpetWashing': 'Teppevask',
  'service.selectService': 'Velg tjeneste',
  'service.addToCart': 'Legg til i handlekurv',
  'service.total': 'Totalt',
  'common.yes': 'Ja',
  'common.no': 'Nei',
  'common.cancel': 'Avbryt',
  'common.confirm': 'Bekreft',
  'common.delete': 'Slett',
  'common.edit': 'Rediger',
  'common.save': 'Lagre',
  'common.search': 'Søk',
  'common.loading': 'Laster...',
  'common.noData': 'Ingen data',
  'common.actions': 'Handlinger',
  'common.status': 'Status',
  'common.date': 'Dato',
  'common.time': 'Tid',
  'common.total': 'Totalt',
  'common.filter': 'Filtrer',
  'common.export': 'Eksporter',
  'common.print': 'Skriv ut',
  'common.close': 'Lukk',
  'common.back': 'Tilbake',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Send',
  'common.reset': 'Tilbakestill',
  'common.create': 'Opprett',
  'common.creating': 'Oppretter...',
  'common.later': 'Senere',
  'common.clear': 'Tøm',
  'common.copied': 'Kopiert!',
  'common.copyError': 'Kopiering mislyktes',
  'common.autoDetected': 'Automatisk oppdaget',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Renseri Administrasjonssystem',
  'login.tenantId': 'Firma-ID',
  'login.tenantPlaceholder': 'firma-id (f.eks: acme-clean)',
  'login.tenantIdHelp': 'Skriv inn din unike firmaidentifikator',
  'login.continue': 'Fortsett →',
  'login.notMember': 'Ikke medlem ennå?',
  'login.startTrial': 'Start gratis prøveperiode',
  'login.adminLogin': '🔒 Administrator pålogging',
  'login.enterPin': 'Skriv inn PIN-koden din',
  'login.changeTenant': 'Bytt firma',
  'login.clear': 'Tøm',
  'login.delete': 'Slett',
  'login.login': 'Logg inn',
  'login.loggingIn': 'Logger inn...',
  'login.defaultPinOwner': 'Standard PIN: <strong>1234</strong> (Eier)',
  'login.defaultPinCashier': 'Standard PIN: <strong>0000</strong> (Kasserer)',
  'login.systemInitializing': 'Initialiserer system...',
  'login.pinMinLength': 'PIN må være minst 4 sifre',
  'login.invalidTenantId': 'Skriv inn en gyldig firma-ID',
  'login.tenantNotFound': 'Denne firmakoden ble ikke funnet. Sjekk eller opprett en ny konto.',
  'login.loginFailed': 'Pålogging mislyktes',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Start gratis prøveperiode',
  'signup.subtitle': '15 dager gratis, ingen kredittkort nødvendig',
  'signup.backToLogin': 'Tilbake til påloggingssiden',
  'signup.companyCode': 'Firmakode',
  'signup.companyCodePlaceholder': 'f.eks: cleanpro',
  'signup.companyCodeHelp': 'Denne koden vil bli brukt for å logge inn i systemet',
  'signup.companyCodeMinLength': 'Firmakoden må være minst 3 tegn',
  'signup.companyName': 'Firmanavn',
  'signup.companyNamePlaceholder': 'Ditt firmanavn',
  'signup.companyNameRequired': 'Firmanavn er påkrevd',
  'signup.fullName': 'Fullt navn',
  'signup.fullNamePlaceholder': 'Ditt fulle navn',
  'signup.fullNameRequired': 'Fullt navn er påkrevd',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+47 900 00 000',
  'signup.validPhoneRequired': 'Skriv inn et gyldig telefonnummer',
  'signup.email': 'E-post',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Skriv inn en gyldig e-postadresse',
  'signup.createAccount': 'Opprett konto',
  'signup.creating': 'Oppretter...',
  'signup.terms': 'Ved å opprette en konto godtar du tjenestevilkårene og personvernerklæringen.',
  'signup.success': 'Registrering vellykket! Din påloggingsinformasjon har blitt sendt til e-posten din.',
  'signup.successTitle': 'Registrering vellykket!',
  'signup.successMessage': 'Kontoen din har blitt opprettet.',
  'signup.emailSent': 'Din påloggingsinformasjon har blitt sendt til e-posten din.',
  'signup.redirecting': 'Omdirigerer til påloggingssiden...',
  'signup.startupPackageLoaded': 'Startpakke lastet!',
  'signup.products': 'Produkter',
  'signup.customers': 'Kunder',
  'signup.users': 'Brukere',
  'signup.demoDataReady': '✨ Demo-dataene dine er klare, du kan begynne å bruke dem umiddelbart!',
  'signup.loginInfo': '📧 Din påloggingsinformasjon',
  'signup.loginInfoSent': '💡 Denne informasjonen har også blitt sendt til e-posten din',
  'signup.loginNow': 'Logg inn nå →',
};
